export default {"src":"/_next/static/media/sadFace.0005bc53.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};